import { render, staticRenderFns } from "./ModalAddMember.vue?vue&type=template&id=054fa9f2"
import script from "./ModalAddMember.vue?vue&type=script&lang=js"
export * from "./ModalAddMember.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports